import React from "react";
import { useState, useEffect, Fragment } from "react";
import AuthService from "../services/auth.service";
import api from "../services/api";
import { Link, useNavigate, useParams, useLocation, useSearchParams } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";
import Weights from "../components/Weights";
import Tabs from "../components/UI/Tabs";
import DiseaseList from "../components/DiseaseList";
import TopBar from "../components/TopBar";
import Vaccines from "../components/Vaccines";
import CalfInfoTab from "../components/calf/CalfInfoTab";
import { CALF_SECTIONS } from "../components/calf/calfSections";
import Milk from "../components/Milk";
function Calf() {
  const currentUser = AuthService.getCurrentUser();
  const [calf, setCalf] = useState({});
  const [view, setView] = useState("veau");
  const [isLoading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [isDownloadLoading, setDownloadLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { from } = location.state || {};
  let { calfId } = useParams();


  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  const getCalf = () => {
    api.get("/calfs/" + calfId)
      .then((response) => {
        setCalf(response.data);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response?.status === 404) {
          setNotFound(true);
          setLoading(false);
        } else if (error.response?.status === 401) {
          navigate("/login");
        } else {
          console.error("There was an error fetching a calf!", error);
        }
      });
  };
  const handleDownload = () => {
    setDownloadLoading(true);
    api
      .get("/print/" + calfId, { responseType: "blob" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `rapport_${calf.name || calfId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setDownloadLoading(false);
      })
      .catch((error) => {
        console.error("There was an error downloading the report!", error);
        setDownloadLoading(false);
      });
  };
  const handleDelete = () => {
    api.delete("/calfs/" + calfId)
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        console.error("There was an error deleting a calf!", error);
      });
  };
  const infoSection = CALF_SECTIONS.find((section) => section.id === view);

  const refreshCalf = () => {
    setLoading(true);
    setCalf({});
    getCalf();
  };
  const changeView = (view) => {
    setView(view);
    setSearchParams({ view: view });
  };

  useEffect(() => {
    const currentUser = AuthService.getCurrentUser();
    if (!currentUser) {
      navigate("/login");
    } else {
      const urlView = searchParams.get("view");
      const initialView = urlView || from || "veau";
      setView(initialView);

      if (urlView && !searchParams.has("view")) {
        setSearchParams({ view: urlView });
      }

      getCalf();
    }
  }, []);
  if (isLoading) {
    return <div>loading</div>;
  } else if (notFound) {
    return (
      <div>
        <TopBar link="/"></TopBar>
        <div>
          <p>Nous n'avons pas pu trouver ce veau dans votre liste de veau.</p>
        </div>
      </div>
    );
  }
  return (
    <div>
      <TopBar link="/"></TopBar>
      <div className="md:flex md:flex-col md:items-center">
        <div className="mb-3 ml-3 flex md:w-[1400px]">
          <div className="flex items-center justify-center rounded-lg bg-stone-200/60 px-3 py-1 dark:bg-slate-700/60">
            <Link to="/">
              <span className="text-sm font-medium text-stone-500 dark:text-slate-300">
                Mes Veaux
              </span>
            </Link>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="mr-1 h-4 w-4 text-stone-300 dark:text-slate-400"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 4.5l7.5 7.5-7.5 7.5"
              />
            </svg>
            <span className="text-sm font-semibold text-stone-700 dark:text-white">
              {calf.name}
            </span>
          </div>
        </div>
        <div className="px-3 md:w-[1400px] md:bg-white dark:md:bg-slate-900">
          <div className="mb-3 rounded-lg bg-white p-1 dark:bg-slate-900">
            <div className="mb-3 ml-2 mt-1 flex justify-between">
              <div>
                <span className="text-2xl font-bold dark:text-white">{calf?.name}</span>
              </div>
              <div className="hidden md:flex">
                <button
                  onClick={() => openModal()}
                  className="mr-3 flex items-center justify-center rounded-md border border-stone-300 bg-white px-3 py-2 text-sm text-stone-800 shadow transition-all duration-100 hover:shadow-inner dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="mr-3 h-4 w-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                    />
                  </svg>
                  Supprimer
                </button>
                <button
                  onClick={() => handleDownload()}
                  disabled={isDownloadLoading ? true : false}
                  className="flex rounded-md border border-amber-500 bg-amber-400 px-3 py-2 text-sm text-white shadow transition-all duration-100 hover:shadow-inner dark:border-amber-600 dark:bg-amber-500 dark:hover:bg-amber-600"
                >
                  <div
                    className={
                      "flex flex-row items-center justify-center " +
                      (isDownloadLoading ? "" : "hidden")
                    }
                  >
                    <svg
                      className="mr-1 h-4 w-4 animate-spin text-amber-600 dark:text-amber-300"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="text-amber-200 dark:text-amber-700"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    <span>Traitement...</span>
                  </div>
                  <div className={isDownloadLoading ? "hidden" : "flex"}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="mr-3 h-4 w-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
                      />
                    </svg>
                    <span>Rapport</span>
                  </div>
                </button>
              </div>
            </div>

          </div>

          <div className="mb-6 hidden w-full border-b border-stone-200 md:block dark:border-slate-600"></div>

          {/*
            One panel of each kind, mounted once. On mobile this is a plain stack
            showing whichever tab is active; from md up the same DOM becomes a
            grid, with the calf's data pinned in the left column and the tab strip
            sitting above the active panel on the right.
          */}
          <div className="flex flex-col">
            <Tabs
              value={view}
              onChange={changeView}
              tabs={[
                ...CALF_SECTIONS.map((section) => ({
                  id: section.id,
                  label: section.label,
                })),
                { id: "weights", label: "Poids" },
                { id: "milk", label: "Lait" },
                { id: "health", label: "Maladies" },
                { id: "vaccin", label: "Vaccins" },
              ]}
              className="self-start"
            />

            <div className="mt-4 w-full">
              {infoSection ? (
                <CalfInfoTab
                  section={infoSection}
                  calf={calf}
                  onSaved={refreshCalf}
                />
              ) : view === "weights" ? (
                <Weights calf={calf}></Weights>
              ) : view === "milk" ? (
                <Milk calfID={calfId}></Milk>
              ) : view === "health" ? (
                <DiseaseList calfID={calfId}></DiseaseList>
              ) : view === "vaccin" ? (
                <Vaccines calfID={calfId}></Vaccines>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-slate-800 dark:border-slate-700">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900 dark:text-white"
                  >
                    Etes-vous sûr de vouloir supprimer {calf.name} ?
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500 dark:text-slate-300">
                      Tous les données concernant {calf.name} seront supprimer
                      et vous ne pourrez plus les récupérer.
                    </p>
                  </div>

                  <div className="mt-4 flex justify-between">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-stone-100 px-4 py-2 text-sm font-medium text-stone-900 hover:bg-stone-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-stone-500 focus-visible:ring-offset-2"
                      onClick={closeModal}
                    >
                      Annuler
                    </button>
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-red-500 px-4 py-2 text-sm font-medium text-white hover:bg-red-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                      onClick={(e) => handleDelete()}
                    >
                      Oui, supprimer
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}

export default Calf;
